import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";

import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { showPopupModal } from "@widgets/CommonModal";
import SnMemoBox from "@shared/components/SnMemoBox";
import { global } from "@shared/libs/Global";
import { fnGetDataSet } from "@shared/api/restApi";
import DesignerGridEdit from "./DesignerGridEdit";
import DesignerFormEdit from "./DesignerFormEdit";
import DesignerSearchEdit from "./DesignerSearchEdit";

interface Props {
  type: string;
  data: any[];
  headerData?: any[];
  onAdd: (value: any[]) => void;
  onChange: (value: any[]) => void;
  onchangeheader?: (value: any[]) => void;
  onSetting?: (value: any) => void;
  settings?: any;
  isPopup?: boolean;
}

const DrawingButtons = forwardRef(
  (
    {
      type,
      data,
      headerData,
      onAdd,
      onChange,
      onchangeheader,
      onSetting,
      settings,
      isPopup,
    }: Props,
    ref
  ) => {
    const addParam = useRef("");
    const { userInfo } = global();

    const add = async () => {
      const component = (
        <div className="w-[550px] h-[300px]">
          <SnMemoBox
            onValueChanged={(value: string) => {
              addParam.current = value;
            }}
          />
        </div>
      );

      const result = await showPopupModal({
        title: `${type} 추가`,
        children: component,
        validation: false,
        width: "610px",
        height: "360px",
        okayBtn: true,
        closeBtn: true,
        checkData: false,
      });
      if (!result || result === "close") return;
      if (type === "조회조건") {
        let id;
        if (isPopup) {
          id = "com_drawing_04";
        } else {
          id = "com_drawing_02";
        }
        const param = {
          id: id,
          params: {
            cd_firm: userInfo.cd_firm,
            nm_label: addParam.current,
          },
        };
        const rtn: any = await fnGetDataSet(param);
        onAdd(rtn);
      } else if (type === "그리드") {
        let id;
        if (isPopup) {
          id = "com_drawing_01";
        } else {
          id = "com_drawing_03";
        }
        const param = {
          id: "com_drawing_01",
          params: {
            cd_firm: userInfo.cd_firm,
            nm_column: addParam.current,
          },
        };

        const rtn: any = await fnGetDataSet(param);
        onAdd(rtn);
      } else if (type === "프리폼" || type === "쉐어드폼") {
        let id;
        if (isPopup) {
          id = "com_drawing_06";
        } else {
          id = "com_drawing_05";
        }
        const param = {
          id: id,
          params: {
            cd_firm: userInfo.cd_firm,
            nm_label: addParam.current,
          },
        };

        const rtn: any = await fnGetDataSet(param);
        onAdd(rtn);
      }
    };

    const edit = async () => {
      if (type === "그리드") {
        const component = (
          <DesignerGridEdit
            type={type}
            columnsData={data}
            gridData={settings}
            columnsData2={headerData || []}
          />
        );
        const result = await showPopupModal({
          title: `${type} 수정`,
          children: component,
          width: "1500px",
          height: "800px",
        });
        if (!result || result === "close") return;
        onChange(result[0]);
        onchangeheader && onchangeheader(result[1]);
        onSetting && onSetting(result[2]);
      }
      if (type === "프리폼") {
        const component = (
          <DesignerFormEdit
            type={type}
            columnsData={data}
            gridData={settings}
            columnsData2={headerData || []}
          />
        );
        const result = await showPopupModal({
          title: `${type} 수정`,
          children: component,
          width: "1500px",
          height: "800px",
        });
        if (!result || result === "close") return;
        onChange(result[0]);
        onchangeheader && onchangeheader(result[1]);
        onSetting && onSetting(result[2]);
      }
      if (type === "조회조건") {
        const component = (
          <DesignerSearchEdit
            type={type}
            columnsData={data}
            gridData={settings}
          />
        );
        const result = await showPopupModal({
          title: `${type} 수정`,
          children: component,
          width: "1500px",
          height: "800px",
        });
        if (!result || result === "close") return;
        onChange(result[0]);
      }
    };

    return (
      <div>
        <EditIcon
          fontSize="large"
          className="w-16 h-16 text-blue-500 hover:text-blue-700 transition-colors absolute bottom-1 right-4 cursor-pointer shadow-lg rounded-full border-2 border-blue-300 bg-white"
          onClick={() => {
            edit();
          }}
        />
        <AddIcon
          fontSize="large"
          className="w-16 h-16 text-blue-500 hover:text-blue-700 transition-colors absolute bottom-1 right-16 cursor-pointer shadow-lg rounded-full border-2 border-blue-300 bg-white"
          onClick={() => {
            add();
          }}
        />
      </div>
    );
  }
);

export default DrawingButtons;
